module.exports = __webpack_public_path__ + "static/media/favoriteIcon.f879d9be.svg";